import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: "#6D8BF0",
        secondary: "#E98A70",
        accent: "#AEBEF5",
        error: "#E39188",
        info: "#4F98F8",
        success: "#6FD976",
        warning: "#E39188",
        darken: "#6075bd",
        footTop: "#3A4061",
        footBottom: "#2F334B",
        voice: "#475CAA",
        nft: "#2aa53f",
        connect: "#C67B73",
        verify: "#9B7DB9",
        academy: "#E98A70"
      }
    }
  }
})

export default vuetify
